import { createContext, useContext } from 'react';
import { CurrentUserStore } from './childStore/currentUserStore';
import { GrispiNewsStore } from './childStore/grispiNewsStore';
import { MacroStore } from './childStore/macroStore';
import { PluginStore } from './childStore/pluginStore';
import { TabStore } from './childStore/tabStore';
import { TicketFormUtilStore } from './childStore/ticketFormUtilStore';
import { UtilStore } from './childStore/utilStore';
import { RootStore } from './rootStore';

export const RootStoreContext = createContext<RootStore>({} as RootStore);

export const useMacroStore = (): MacroStore => useContext(RootStoreContext).MacroStore;
export const useTabStore = (): TabStore => useContext(RootStoreContext).TabStore;
export const usePluginStore = (): PluginStore => useContext(RootStoreContext).PluginStore;
export const useTicketFormUtilStore = (): TicketFormUtilStore => useContext(RootStoreContext).TicketFormUtilStore;
export const useCurrentUserStore = (): CurrentUserStore => useContext(RootStoreContext).CurrentUserStore;
export const useUtilStore = (): UtilStore => useContext(RootStoreContext).UtilStore;
export const useGrispiNewsStore = (): GrispiNewsStore => useContext(RootStoreContext).GrispiNewsStore;
